
import ViewBox from 'vux/src/components/view-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'

import IndexHeader from '@/components/IndexHeader'
import IndexSidebar from '@/components/IndexSidebar'
import IndexFooter from '@/components/IndexFooter'

export default {
components: {
ViewBox,
Flexbox,
FlexboxItem,
Grid,
GridItem,
Swiper,
SwiperItem,
IndexHeader,
IndexSidebar,
IndexFooter
},
data () {
return {
gridNavbarContent: [
{
toPath: '/promotionWechat',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_wechat.png',
theme: '微信营销'
}, {
toPath: '/promotionXhs',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/gris_xhs.png',
theme: '小红书推广'
}, {
toPath: '/promotionWeibo',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_weibo.png',
theme: '微博营销'
}, {
toPath: '/promotionLive',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_live.png',
theme: '网红直播'
}, {
toPath: '/promotionVideo',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_video.png',
theme: '视频营销'
}, {
toPath: '/promotionWxzf',
imgSrc: 'https://static.xinmeibao.com/assets_mobile/v2/grid_wxzf.png',
theme: '公众号引流'
}

],
indexResource: [
{
iconName: 'ziyuan1',
numberIndex: '01',
themeH3: '资源',
themeP: '全平台覆盖，全行业整合，海量优质资源'
},
{
iconName: 'shuju',
numberIndex: '02',
themeH3: '数据',
themeP: '智能大数据系统，精准定位，精准数据输出'
},
{
iconName: 'chuangyi',
numberIndex: '03',
themeH3: '创意',
themeP: '直击人心，匹配品牌调性的刷屏级内容'
},
{
iconName: 'jishu',
numberIndex: '04',
themeH3: '技术',
themeP: '后台匹配前端，技术驱动营销，完美效果呈现'
},
{
iconName: 'fuwu',
numberIndex: '05',
themeH3: '服务',
themeP: '专业团队一对一VIP服务，量身定制推广策略'
},
{
iconName: 'jingyan',
numberIndex: '06',
themeH3: '经验',
themeP: '已为国内外各领域客户完成千万次曝光'
}
],
solutionList: [
{
toPath: '/solution/appPromotion',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/app_icon.png',
solutionLabel: 'APP推广'
},
{
toPath: '/solution/smallProgram',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/xcx_icon.png',
solutionLabel: '小程序推广'
},
{
toPath: '/solution/game',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/yx_icon.png',
solutionLabel: '游戏行业推广'
},
{
toPath: '/solution/ecommerce',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ds_icon.png',
solutionLabel: '电商行业推广'
},
{
toPath: '/solution/finance',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/jr_icon.png',
solutionLabel: '金融行业推广'
},
{
toPath: '/solution/microBussiness',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ws_icon.png',
solutionLabel: '微商行业推广'
},
{
toPath: '/solution/tourism',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/ly_icon.png',
solutionLabel: '旅游行业推广'
},
{
toPath: '/solution/fmcg',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/kx_icon.png',
solutionLabel: '快消品行业推广'
},
{
toPath: '/solution/fashionBeauty',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/mz_icon.png',
solutionLabel: '时尚美容推广'
},
{
toPath: '/solution/newProduct',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/xp_icon.png',
solutionLabel: '新品推广'
},
{
toPath: '/solution/motherChild',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/my_icon.png',
solutionLabel: '母婴行业推广'
},
{
toPath: '/solution/car',
imgSrc: 'http://xinmeibao.oss-cn-hangzhou.aliyuncs.com/xmb_wap/img/qc_icon.png',
solutionLabel: '汽车行业推广'
}
]
}
},
methods: {}
}



// WEBPACK FOOTER //
// ./src/pages/index/index.vue